import React, { PropsWithChildren, useRef } from 'react';
import { ButtonProps } from '../../../../types/HtmlProps';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

export enum AccordionToggleButtonModifier {
  NO_PADDING_LEFT = 'no-padding-left',
  SMALL = 'small',
}

interface AccordionToggleButtonProps extends ButtonProps {
  modifier?: Modifier<AccordionToggleButtonModifier>;
  ref?: React.RefObject<HTMLButtonElement | null>;
}

export function AccordionToggleButton({
  children,
  modifier,
  ref,
  ...buttonProps
}: PropsWithChildren<AccordionToggleButtonProps>) {
  return (
    <button ref={ref} {...buttonProps} className={bem('accordion__button', modifier)} type="button">
      {children}
    </button>
  );
}

export function AccordionToggleButtonWithTooltip({
  children,
  tooltipPlacement,
  ...buttonProps
}: PropsWithChildren<
  {
    tooltipPlacement?: TooltipPlacement;
  } & ButtonProps
>) {
  const buttonRef = useRef<HTMLButtonElement>(null);
  return (
    <Tooltip attachTo={buttonRef} placement={tooltipPlacement}>
      <AccordionToggleButton {...buttonProps} ref={buttonRef}>
        {children}
      </AccordionToggleButton>
    </Tooltip>
  );
}
